import {Pipe, PipeTransform} from '@angular/core';
import {countOf} from './admin-dashboard-text';

/** `{{ n | adbCount:'company':'companies' }}` → "1 company" / "2 companies" (see countOf). */
@Pipe({name: 'adbCount', standalone: false, pure: true})
export class AdminDashboardCountPipe implements PipeTransform {
  transform(n: number, one: string, many?: string): string {
    return countOf(n, one, many);
  }
}
